import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RegistroPontoAlteracao } from '../../api.service';

@Component({
  selector: 'app-modal-historico-folha',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-historico-folha.component.html',
  styleUrls: ['../../shared/modal-pesquisa-lista.component.css', './modal-historico-folha.component.css']
})
export class ModalHistoricoFolhaComponent {
  @Input() aberta = false;
  @Input() carregando = false;
  @Input() titulo = 'Historico da folha';
  @Input() erro = '';
  @Input() alteracoes: RegistroPontoAlteracao[] = [];

  @Output() fechar = new EventEmitter<void>();

  rotuloOperacao(operacao: string) {
    if (operacao === 'EXCLUSAO') {
      return 'Exclusao';
    }
    if (operacao === 'INCLUSAO') {
      return 'Inclusao';
    }
    return 'Alteracao';
  }
}
